import React from 'react';

function InvoiceCoverSec({factor}) {
    return(
        <div className="prev-image"
             style={{background: `rgba(0, 0, 0, .45) url(${factor.merchant?factor.merchant.cover:""})`}}>
            <div className="prev-footer">
                <div className="prev-image-logo">
                    {factor.merchant?<img src={factor.merchant.thumbnail} alt=""/>:null}
                </div>
                <div className="prev-image-title">
                    {factor.merchant?<span>{factor.merchant.name}</span>:null}
                </div>
                <div className="prev-image-address">
                    {factor.merchant?<span>{factor.merchant.address?factor.merchant.address:"بدون آدرس"}</span>:null}
                </div>
            </div>
        </div>
    )

}


export {InvoiceCoverSec}
